import { Reveal } from "@/components/Reveal";

const STATS = [
  { value: "10+", label: "Yıl Deneyim" },
  { value: "500+", label: "Mutlu Çift" },
  { value: "25", label: "Ankara İlçesi" },
  { value: "4.9", label: "Google Puanı" },
];

export const TrustBar = () => (
  <section className="relative z-10 bg-[#141517] border-y border-white/8">
    <div className="container-lux grid grid-cols-2 md:grid-cols-4 divide-x divide-white/8">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.06}>
          <div className="py-8 text-center">
            <div className="font-display text-4xl sm:text-5xl text-[#D7B86A]">{s.value}</div>
            <div className="text-xs sm:text-sm uppercase tracking-[0.14em] text-[#9A9387] mt-2">{s.label}</div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default TrustBar;
